const pre = 'message-';

export default [{
  path: '/message/index',
  name: `${pre}index`,
  meta: {
    title: '消息列表'
  },
  component: () =>
    import ('@/views/message/index')
  },

]
